module.exports = __webpack_public_path__ + "static/gold-dragon-wyrmling-with-paladin-bbd35c1014d2a9cc801f0143b71a7543.jpg";